import type { BadgeProps } from '@/components/ui'

type BadgeVariant = NonNullable<BadgeProps['variant']>

export type RiskLevelLabelKey =
  | 'integrations.riskLevels.readOnly'
  | 'integrations.riskLevels.lowRiskWrite'
  | 'integrations.riskLevels.highRiskWrite'
  | 'integrations.riskLevels.destructive'

interface RiskLevelMeta {
  readonly labelKey: RiskLevelLabelKey
  /** Cor do nivel: leitura = neutro/discreto; escrita = info; escrita sensivel = warning; destrutiva = danger. */
  readonly badgeVariant: BadgeVariant
}

const RISK_LEVEL_META: Record<string, RiskLevelMeta> = {
  ReadOnly: { labelKey: 'integrations.riskLevels.readOnly', badgeVariant: 'neutral' },
  LowRiskWrite: { labelKey: 'integrations.riskLevels.lowRiskWrite', badgeVariant: 'info' },
  HighRiskWrite: { labelKey: 'integrations.riskLevels.highRiskWrite', badgeVariant: 'warning' },
  Destructive: { labelKey: 'integrations.riskLevels.destructive', badgeVariant: 'danger' },
}

/**
 * Traduz o `riskLevel` cru do backend para o vocabulario de produto: nunca expor o enum tecnico
 * direto. `null` = nivel desconhecido (valor futuro do backend): quem consome mostra o valor cru,
 * com cor neutra, em vez de inventar um rotulo. Hoje so `ReadOnly` ("Leitura") aparece.
 */
export function riskLevelMeta(riskLevel: string): RiskLevelMeta | null {
  return RISK_LEVEL_META[riskLevel] ?? null
}
